module.exports = __webpack_public_path__ + "static/media/448081204_773661577937759_791327755226639305_n.21313126.jpg";